import { useLang } from "@/i18n/LanguageContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { CaretDown } from "@phosphor-icons/react";

const LABELS = { az: "AZ", ru: "RU", en: "EN" };

export const LanguageSwitcher = () => {
  const { lang, setLang } = useLang();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid="lang-switcher-btn"
          variant="ghost"
          size="sm"
          className="rounded-full h-9 px-3 gap-1 font-semibold tracking-wide"
        >
          {LABELS[lang]} <CaretDown size={12} weight="bold" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[80px]">
        {Object.entries(LABELS).map(([k, v]) => (
          <DropdownMenuItem
            key={k}
            data-testid={`lang-option-${k}`}
            onClick={() => setLang(k)}
            className={lang === k ? "bg-accent font-semibold" : ""}
          >
            {v}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
